// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__SO0Ce","inputWrap":"Table_inputWrap__3Tg2g","col":"Table_col__3utkH","bmiTooltip":"Table_bmiTooltip__3gEJX"};